import { TranslateInMemoryLoader } from './TranslateInMemoryLoader';

/**
 * Chargement des traductions avec un segment aléatoire pour éviter que le
 * navigateur ne mette en cache le fichier de traduction.
 */
export function createTranslateLoader() {
  return new TranslateInMemoryLoader();
}
